// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import Sidebar from "../../Components/Sidebar";
// import PageComponent from "../../Components/PageComponent";
// import { MdOutlineDeleteForever } from "react-icons/md";
// import { FaRegEdit } from "react-icons/fa";
// import {
//   addIntake,
//   getIntakes,
//   updateIntake,
//   deleteIntake,
// } from "../../controllers/aluminiIntakes.controller";
// import DeletePopup from "../../Components/DeletePopup";
// import UpdateIntakePopup from "./UpdateIntakePopup";
// import { fetchDegreeNames } from "../../redux/actions/degreeActions";
// import { getAlumniRegData } from "../../controllers/alumniRegistration.controller";
// import AlumniEditForm from "./AlumniEditForm";  // Import the new component

// function AlumniDirectory() {
//   const dispatch = useDispatch();
//   const [intakes, setIntakes] = useState([]);
//   const [alumniData, setAlumniData] = useState([]);
//   const [intake, setIntake] = useState("");
//   const [degree, setDegree] = useState("");
//   const [editId, setEditId] = useState(null);

//   const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
//   const [selectedIntake, setSelectedIntake] = useState(null);

//   const [isUpdatePopupOpen, setIsUpdatePopupOpen] = useState(false);
//   const [intakeToUpdate, setIntakeToUpdate] = useState(null);

//   const [editingAlumni, setEditingAlumni] = useState(null);  // New state
//   const [degreenames, setDegreenames] = useState([])

//   const degreenamesData = useSelector((state) => state.degree.degrees.data) || [];

//   useEffect(() => {
//     fetchIntakes();
//     fetchAlumniData();
//     dispatch(fetchDegreeNames());
//     setDegreenames(degreenamesData)
//   }, [degreenamesData]);

//   const fetchIntakes = async () => {
//     try {
//       const response = await getIntakes();
//       setIntakes(response.data.data);
//     } catch (error) {
//       console.error("Error fetching intakes:", error);
//     }
//   };

//   const fetchAlumniData = async () => {
//     try {
//       const response = await getAlumniRegData("?approvalStatus=Approved");
//       console.log("API Response:", response);
//       if (response.status === 200) {
//         setAlumniData(response.data.data);
//       } else {
//         console.error("Failed to fetch alumni data");
//       }
//     } catch (error) {
//       console.error("Error fetching alumni data:", error);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!intake) {
//       alert("Please enter an intake name.");
//       return;
//     }

//     if (!degree) {
//       alert("Please enter degree.");
//       return;
//     }
//     try {
//       await addIntake({ alumniIntake: intake, degreeProgram: degree });
//       alert("Intake added successfully!");
//       setIntake("");
//       fetchIntakes();
//     } catch (error) {
//       console.error("Error saving intake:", error);
//       alert("Failed to save intake.");
//     }
//   };

//   const handleDeleteClick = (intake) => {
//     setSelectedIntake(intake);
//     setIsDeletePopupOpen(true);
//   };

//   const handleConfirmDelete = async () => {
//     try {
//       if (selectedIntake) {
//         await deleteIntake({ id: selectedIntake.id });
//         alert("Intake deleted successfully!");
//         fetchIntakes();
//       }
//     } catch (error) {
//       console.error("Error deleting intake:", error);
//       alert("Failed to delete intake.");
//     } finally {
//       setIsDeletePopupOpen(false);
//       setSelectedIntake(null);
//     }
//   };

//   const handleCloseDeletePopup = () => {
//     setIsDeletePopupOpen(false);
//     setSelectedIntake(null);
//   };

//   const handleEditClick = (intake) => {
//     setIntakeToUpdate(intake);
//     setIsUpdatePopupOpen(true);
//   };

//   const handleCloseUpdatePopup = () => {
//     setIsUpdatePopupOpen(false);
//     setIntakeToUpdate(null);
//   };

//   const handleUpdateIntake = async (id, updatedIntakeData) => {
//     try {
//       await updateIntake({
//         id,
//         alumniIntake: updatedIntakeData.alumniIntake,
//         degreeProgram: updatedIntakeData.degreeProgram,
//       });
//       fetchIntakes();
//     } catch (error) {
//       console.error("Error updating intake:", error);
//       alert("Failed to update intake.");
//     }
//   };

//   const handleEditAlumni = (alumni) => {
//     setEditingAlumni(alumni);
//   };

//   const handleUpdateAlumni = async (updatedData) => {
//     // Here you would make an API call to update the alumni data
//     // with the `updatedData`.  For this example, we'll just
//     // update the state.
//     try {
//       // Replace this with your actual API call to update
//       // await updateAlumniData(editingAlumni.id, updatedData);

//       // Optimistically update the state
//       setAlumniData(
//         alumniData.map((item) =>
//           item.id === editingAlumni.id
//             ? { ...item, ...updatedData }
//             : item
//         )
//       );
//       setEditingAlumni(null); // Close the form
//       alert("Alumni data updated successfully!");
//     } catch (error) {
//       console.error("Error updating alumni data:", error);
//       alert("Failed to update alumni data.");
//     }
//   };

//   const handleCloseEditForm = () => {
//     setEditingAlumni(null);
//   };

//   return (
//     <PageComponent>
//       <div className="flex w-screen h-screen overflow-x-hidden bg-[#F8F7FA]">
//         <div className="fixed top-0 left-0 w-64 h-full bg-white shadow-md">
//           <Sidebar />
//         </div>
//         <div className="flex-1 p-6 ml-64">
//           <div className="flex items-center space-x-2 text-3xl text-gray-500">
//             <span>Alumni</span>
//             <span>/</span>
//             <span className="text-black">Alumni Directory</span>
//           </div>

//           <div className="p-4 mt-4 bg-white border border-gray-300 rounded-lg shadow-md">
//             <h2 className="mb-4 text-xl font-semibold text-gray-700">Approved Alumni</h2>

//             {/* Horizontal scroll wrapper */}
//             <div className="w-full overflow-x-auto">
//               <table className="min-w-full border border-gray-300 table-auto">
//                 <thead>
//                   <tr className="text-left text-gray-600 bg-gray-100">
//                     <th className="px-4 py-2">RID</th>
//                     <th className="px-4 py-2">Name</th>
//                     <th className="px-4 py-2">Permanent Address</th>
//                     <th className="px-4 py-2">Correspondence Address</th>
//                     <th className="px-4 py-2">Action</th>
//                     <th className="px-4 py-2">Mobile Number</th>
//                     <th className="px-4 py-2">Resident Number</th>
//                     <th className="px-4 py-2">Personal Email</th>
//                     <th className="px-4 py-2">Office Email</th>
//                     <th className="px-4 py-2">NIC/Passport Number</th>
//                     <th className="px-4 py-2">Profession/Designation</th>
//                     <th className="px-4 py-2">Official Address</th>
//                     <th className="px-4 py-2">BSc. (Applied Accounting)</th>
//                     <th className="px-4 py-2">Year of Enrollment</th>
//                     <th className="px-4 py-2">SAB Registration Number</th>
//                     <th className="px-4 py-2">Intake</th>
//                     <th className="px-4 py-2">Year of Obtaining Degree</th>
//                     <th className="px-4 py-2">Approval Status</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {alumniData.length > 0 ? (
//                     alumniData.map((item) => (
//                       <tr key={item.id} className="border-b border-gray-300">
//                         <td className="px-4 py-2">{item.reg_no}</td>
//                         <td className="px-4 py-2">{item.name}</td>
//                         <td className="px-4 py-2">{item.permanent_address}</td>
//                         <td className="px-4 py-2">{item.correspondence_address}</td>
//                         <td className="px-4 py-2">
//                           <button
//                             className="px-4 py-2 border rounded text-primary-color border-primary-color bg-primary-color bg-opacity-10"
//                             onClick={() => handleEditAlumni(item)}
//                           >
//                             Edit
//                           </button>
//                         </td>
//                         <td className="px-4 py-2">{item.mobile_no}</td>
//                         <td className="px-4 py-2">{item.resident_no}</td>
//                         <td className="px-4 py-2">{item.personal_email}</td>
//                         <td className="px-4 py-2">{item.office_email}</td>
//                         <td className="px-4 py-2">{item.nic_passport_no}</td>
//                         <td className="px-4 py-2">{item.designation}</td>
//                         <td className="px-4 py-2">{item.official_address}</td>
//                         <td className="px-4 py-2">{item.sab_academic_qualifications}</td>
//                         <td className="px-4 py-2">{item.year_of_enrollment}</td>
//                         <td className="px-4 py-2">{item.sab_reg_no}</td>
//                         <td className="px-4 py-2">{item.intake}</td>
//                         <td className="px-4 py-2">{item.year_of_degree_obtained}</td>
//                         <td className="px-4 py-2">{item.approval_status}</td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan="17" className="px-4 py-2 text-center text-gray-500">
//                         No approved alumni available.
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {/* Render the Edit Form Conditionally */}
//           {editingAlumni && (
//             <AlumniEditForm
//               alumni={editingAlumni}
//               onClose={handleCloseEditForm}
//               onUpdate={handleUpdateAlumni}
//             />
//           )}
//         </div>

//         <DeletePopup
//           title="Intake"
//           isOpen={isDeletePopupOpen}
//           onClose={handleCloseDeletePopup}
//           onConfirm={handleConfirmDelete}
//           data={selectedIntake?.alumni_intake || ""}
//         />

//         <UpdateIntakePopup
//           title="Update Intake"
//           isOpen={isUpdatePopupOpen}
//           onClose={handleCloseUpdatePopup}
//           fetchIntakes={fetchIntakes}
//           updateIntake={handleUpdateIntake}
//           data={intakeToUpdate}
//           degreeNames={degreenames}
//         />
//       </div>
//     </PageComponent>
//   );
// }

// export default AlumniDirectory;

import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "../../Components/Sidebar";
import PageComponent from "../../Components/PageComponent";
import {
    addIntake,
    getIntakes,
    updateIntake,
    deleteIntake,
} from "../../controllers/aluminiIntakes.controller";
import DeletePopup from "../../Components/DeletePopup";
import UpdateIntakePopup from "./UpdateIntakePopup";
import { fetchDegreeNames } from "../../redux/actions/degreeActions";
import { getAlumniRegData } from "../../controllers/alumniRegistration.controller";
import AlumniEditForm from "./AlumniEditForm";
import { updateAlumniRegistration } from "../../controllers/alumniRegistration.controller";

function AlumniDirectory() {
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [alumniData, setAlumniData] = useState([]);
    const [searchName, setSearchName] = useState("");
    const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
    const [selectedIntake, setSelectedIntake] = useState(null);
    const [isUpdatePopupOpen, setIsUpdatePopupOpen] = useState(false);
    const [intakeToUpdate, setIntakeToUpdate] = useState(null);
    const [editingAlumni, setEditingAlumni] = useState(null);
    const degreenamesData = useSelector((state) => state.degree.degrees.data) || [];

    const fetchAlumniData = useCallback(async () => {
        try {
            let url = `?approvalStatus=Approved&page=${currentPage}&pageSize=${itemsPerPage}`;
            if (searchName) {
                url += `&name=${searchName}`;
            }

            const response = await getAlumniRegData(url);
            console.log("API Response:", response);
            if (response.status === 200) {
                setAlumniData(response.data.data);
                setTotalPages(response.data.pagination.total_pages);
            } else {
                console.error("Failed to fetch alumni data");
            }
        } catch (error) {
            console.error("Error fetching alumni data:", error);
        }
    }, [searchName, currentPage, itemsPerPage]);

    useEffect(() => {
        fetchAlumniData();
    }, [fetchAlumniData, dispatch]);

    useEffect(() => {
        console.log("degreenamesData changed:", degreenamesData);
    }, [degreenamesData]);

    const handleConfirmDelete = async () => {
        try {
            if (selectedIntake) {
                await deleteIntake({ id: selectedIntake.id });
                alert("Intake deleted successfully!");
            }
        } catch (error) {
            console.error("Error deleting intake:", error);
            alert("Failed to delete intake.");
        } finally {
            setIsDeletePopupOpen(false);
            setSelectedIntake(null);
        }
    };

    const handleCloseDeletePopup = () => {
        setIsDeletePopupOpen(false);
        setSelectedIntake(null);
    };

    const handleEditClick = (intake) => {
        setIntakeToUpdate(intake);
        setIsUpdatePopupOpen(true);
    };

    const handleCloseUpdatePopup = () => {
        setIsUpdatePopupOpen(false);
        setIntakeToUpdate(null);
    };

    const handleUpdateIntake = async (id, updatedIntakeData) => {
        try {
            await updateIntake({
                id,
                alumniIntake: updatedIntakeData.alumniIntake,
                degreeProgram: updatedIntakeData.degreeProgram,
            });
        } catch (error) {
            console.error("Error updating intake:", error);
            alert("Failed to update intake.");
        }
    };

    const handleEditAlumni = (alumni) => {
        setEditingAlumni(alumni);
    };

    const handleUpdateAlumni = async (updatedData) => {
        try {
            await updateAlumniRegistration(editingAlumni.id, updatedData);
            setAlumniData(
                alumniData.map((item) =>
                    item.id === editingAlumni.id ? { ...item, ...updatedData } : item
                )
            );
            setEditingAlumni(null);
            fetchAlumniData();
            alert("Alumni data updated successfully!");
        } catch (error) {
            console.error("Error updating alumni data:", error);
            alert("Failed to update alumni data.");
        }
    };

    const handleCloseEditForm = () => {
        setEditingAlumni(null);
    };

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleSearchChange = (e) => {
        setSearchName(e.target.value);
        setCurrentPage(1);
    };

    // Function to generate pagination numbers
    const getPaginationNumbers = () => {
        const pagesToShow = 3; // Adjust as needed: total number of page numbers to display
        const pageNumbers = [];

        // Always add the first page
        if (totalPages <= 1) return pageNumbers; // no pages to show.

        const middlePage = Math.floor(pagesToShow / 2); //how many neighbors to show on each side of the current page
        let startPage = Math.max(1, currentPage - middlePage);
        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

        //adjust start page if we are too close to the end page
        if(totalPages - currentPage < middlePage){
          startPage = Math.max(1, totalPages - pagesToShow + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }

        return pageNumbers;
    };

    return (
        <PageComponent>
            <div className="flex w-screen h-screen overflow-x-hidden bg-[#F8F7FA]">
                <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
                    <Sidebar />
                </div>
                <div className="flex-1 p-6 ml-64">
                    <div className="flex items-center space-x-2 text-3xl text-gray-500">
                        <span>Alumni</span>
                        <span>/</span>
                        <span className="text-black">Alumni Directory</span>
                    </div>

                    <input
                        type="text"
                        placeholder="Search by Name"
                        value={searchName}
                        onChange={handleSearchChange}
                        className="w-full max-w-md p-2 mt-4 border border-gray-300 rounded-md"
                    />

                    <div className="p-4 mt-4 bg-white border border-gray-300 rounded-lg shadow-md">
                        <h2 className="mb-4 text-xl font-semibold text-gray-700">Approved Alumni</h2>

                        <div className="overflow-x-scroll w-[calc(100vw-22rem)] max-h-96 scrollbar-custom">
                            <table className="border border-gray-300 table-auto">
                                <thead>
                                    <tr className="text-left text-gray-600 bg-gray-100">
                                        <th className="px-4 py-2">RID</th>
                                        <th className="px-4 py-2">Name</th>
                                        <th className="px-4 py-2">Permanent Address</th>
                                        <th className="px-4 py-2">Correspondence Address</th>
                                        <th className="px-4 py-2">Mobile Number</th>
                                        <th className="px-4 py-2">Resident Number</th>
                                        <th className="px-4 py-2">Personal Email</th>
                                        <th className="px-4 py-2">Office Email</th>
                                        <th className="px-4 py-2">NIC/Passport Number</th>
                                        <th className="px-4 py-2">Profession/Designation</th>
                                        <th className="px-4 py-2">Official Address</th>
                                        <th className="px-4 py-2">BSc. (Applied Accounting)</th>
                                        <th className="px-4 py-2">Year of Enrollment</th>
                                        <th className="px-4 py-2">SAB Registration Number</th>
                                        <th className="px-4 py-2">Intake</th>
                                        <th className="px-4 py-2">Year of Obtaining Degree</th>
                                        <th className="px-4 py-2">Approval Status</th>
                                        <th className="px-4 py-2">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {alumniData.length > 0 ? (
                                        alumniData.map((item) => (
                                            <tr key={item.id} className="border-b border-gray-300">
                                                <td className="px-4 py-2">{item.reg_no}</td>
                                                <td className="px-4 py-2">{item.name}</td>
                                                <td className="px-4 py-2">{item.permanent_address}</td>
                                                <td className="px-4 py-2">{item.correspondence_address}</td>
                                                <td className="px-4 py-2">{item.mobile_no}</td>
                                                <td className="px-4 py-2">{item.resident_no}</td>
                                                <td className="px-4 py-2">{item.personal_email}</td>
                                                <td className="px-4 py-2">{item.office_email}</td>
                                                <td className="px-4 py-2">{item.nic_passport_no}</td>
                                                <td className="px-4 py-2">{item.designation}</td>
                                                <td className="px-4 py-2">{item.official_address}</td>
                                                <td className="px-4 py-2">{item.sab_academic_qualifications}</td>
                                                <td className="px-4 py-2">{item.year_of_enrollment}</td>
                                                <td className="px-4 py-2">{item.sab_reg_no}</td>
                                                <td className="px-4 py-2">{item.intake}</td>
                                                <td className="px-4 py-2">{item.year_of_degree_obtained}</td>
                                                <td className="px-4 py-2">{item.approval_status}</td>
                                                <td className="px-4 py-2">
                                                    <button
                                                        className="px-4 py-2 border rounded text-primary-color border-primary-color bg-primary-color bg-opacity-10"
                                                        onClick={() => handleEditAlumni(item)}
                                                    >
                                                        Edit
                                                    </button>
                                                </td>

                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="17" className="px-4 py-2 text-center text-gray-500">
                                                No approved alumni available.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Pagination */}
                   <div className="flex justify-center mt-4">
                        <button
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="px-4 py-2 mx-1 text-gray-700 bg-gray-200 rounded-full disabled:opacity-50"
                        >
                            Previous
                        </button>

                        {getPaginationNumbers().map((number) => (
                            <button
                                key={number}
                                onClick={() => paginate(number)}
                                className={`px-4 py-2 mx-1 rounded-full ${currentPage === number ? 'bg-primary-color text-white' : 'bg-gray-200 text-gray-700'}`}
                            >
                                {number}
                            </button>
                        ))}

                        <button
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="px-4 py-2 mx-1 text-gray-700 bg-gray-200 rounded-full disabled:opacity-50"
                        >
                            Next
                        </button>
                    </div>

                    {editingAlumni && (
                        <AlumniEditForm
                            alumni={editingAlumni}
                            onClose={handleCloseEditForm}
                            onUpdate={handleUpdateAlumni}
                        />
                    )}
                </div>

                <DeletePopup
                    title="Intake"
                    isOpen={isDeletePopupOpen}
                    onClose={handleCloseDeletePopup}
                    onConfirm={handleConfirmDelete}
                    data={selectedIntake?.alumni_intake || ""}
                />

                <UpdateIntakePopup
                    title="Update Intake"
                    isOpen={isUpdatePopupOpen}
                    onClose={handleCloseUpdatePopup}
                    updateIntake={handleUpdateIntake}
                    data={intakeToUpdate}
                    degreeNames={degreenamesData}
                />
            </div>
        </PageComponent>
    );
}

export default AlumniDirectory;